import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from "rxjs";

import { AdminGroupsModel, McfModel, SincsNotificationSettingsModel } from '@app/models/failure/admin.model';

@Injectable({ providedIn: 'root' })
export class AdminService {

  private apiUrl = `${environment.apiUrl}/api/admin/`;
  private apiUrlRedis = `${environment.apiUrl}/api/redis/`;

  constructor(public httpClient: HttpClient) { }

  public getMCF(): Observable<McfModel[]> {
    return this.httpClient.get<McfModel[]>(`${this.apiUrl}/MCF`);
  }

  public getMCF_Cache(): Observable<McfModel[]> {
    return this.httpClient.get<McfModel[]>(`${this.apiUrlRedis}get?key=MCF`);
  }

  public postMCF(paramsData: any) {
    return this.httpClient.post(`${this.apiUrl}/MCF`, { params: paramsData });
  }

  public postCreateGroup(groupData: any) {
    return this.httpClient.post(`${this.apiUrl}/createGroup/`, groupData, {});
  }

  public getGroupsByPersonId(personId: number): Observable<AdminGroupsModel[]> {
    return this.httpClient.get<AdminGroupsModel[]>(`${this.apiUrl}/getGroups/${personId}`, {});
  }

  public getSincsNotificationSettings(): Observable<SincsNotificationSettingsModel[]> {
    return this.httpClient.get<SincsNotificationSettingsModel[]>(`${this.apiUrl}/sincs/notificationSettings/`, {});
  }

  public postSincsNotificationSettings(paramsData: any) {
    return this.httpClient.post(`${this.apiUrl}/sincs/notificationSettings/`, paramsData, {});
  }

  public getBulletinBoardKPIbyId(kpiMode: number, ifcId: number): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.apiUrl}/bulletinBoardCount/${kpiMode}/${ifcId}`, {});
  }

  public postReferenceValue(paramsData: any) {
    return this.httpClient.post(`${this.apiUrl}/referenceValue`, paramsData);
  }

  public getSuffixEgiRelationData(): any {
    return this.httpClient.get<any>(`${this.apiUrl}/egiSuffixRelation`);
  }

  public getPlaceElrRelationData(): any {
    return this.httpClient.get<any>(`${this.apiUrl}/placeELRRelation`);
  }

  public getSymptomSuffixRelationData(): any {
    return this.httpClient.get<any>(`${this.apiUrl}/symptomSuffixRelation`);
  }

  public postSymptomSuffixRelationData(obj) {
    return this.httpClient.post(`${this.apiUrl}/symptomSuffixRelation`, obj);
  }

  public postPlaceElrRelationData(obj) {
    return this.httpClient.post(`${this.apiUrl}/placeELRRelation`, obj);
  }

  public postEgiSuffixRelationData(obj) {
    return this.httpClient.post(`${this.apiUrl}/egiSuffixRelation`, obj);
  }

  public postPlace(obj) {
    return this.httpClient.post(`${this.apiUrl}/place`, obj);
  }

  public postSuffix(obj) {
    return this.httpClient.post(`${this.apiUrl}/suffix`, obj);
  }
  
  public postMcf(obj) {
    return this.httpClient.post(`${this.apiUrl}/MCF`, obj);
  }

}
